module.exports = __webpack_public_path__ + "static/media/devicesyncuser.2ade4f98.svg";